/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/media-has-caption */
import { Add, InfoCircle } from 'iconsax-react';
import PropTypes from 'prop-types';
import banner from '../../assets/images/icons/banner.svg';
import document from '../../assets/images/icons/document.svg';
import video from '../../assets/images/icons/video.svg';
import profile from '../../assets/images/profile.svg';
import Text from '../../assets/styles/Text';
import * as styles from './styles';

export default function GroupFile({
  children,
  type,
  error = null,
  title,
  idForm,
  required = true,
  prev = null,
}) {
  function chooseIcon(num) {
    switch (num) {
      case 2:
        return <img src={banner} alt="imagem input" />;

      case 3:
        return <img src={document} alt="imagem input" />;

      case 4:
        return <img src={video} alt="imagem input" />;

      default:
        return <img src={profile} alt="imagem input" />;
    }
  }

  console.log(prev);
  console.log({ prev });

  return (
    <styles.Container $error={error}>
      <styles.Label htmlFor={idForm}>
        {children}

        {chooseIcon(type)}

        <styles.GroupButton>
          <Text.H4>{title}</Text.H4>

          <styles.Button type="button" $padding={10} $radius={32}>
            <Text.P>Envie agora</Text.P>
          </styles.Button>

          {required && <Text.Span>Obrigatório</Text.Span>}
        </styles.GroupButton>
      </styles.Label>

      {prev && (
        <styles.GroupImg>
          {prev?.profile_photo && (
            <img src={prev.profile_photo} alt="perfil" className="profile" />
          )}

          {prev?.banner_photo && (
            <img src={prev.banner_photo} alt="banner" className="banner" />
          )}

          {prev?.verification_media && (
            <video controls src={prev.verification_media} />
          )}

          {prev?.document_photo && (
            <img src={prev.document_photo} alt="banner" className="banner" />
          )}

          {prev?.uploads?.map((upload, index) => (
            <styles.WrapUpload key={upload.id}>
              <button type="button" onClick={() => prev?.func(upload.name)}>
                <Add size={24} />
              </button>

              {upload.media_type === 'photo' ? (
                <img src={upload.url} alt={`upload-${index}`} />
              ) : (
                <video controls src={upload.url} />
              )}
            </styles.WrapUpload>
          ))}
        </styles.GroupImg>
      )}

      {error && (
        <styles.Error>
          <InfoCircle />
          <Text.Span>{error}</Text.Span>
        </styles.Error>
      )}
    </styles.Container>
  );
}

GroupFile.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  idForm: PropTypes.string.isRequired,
  type: PropTypes.number,
  error: PropTypes.string,
  required: PropTypes.bool,
  prev: PropTypes.any,
};
